import React from "react"
import PropTypes from "prop-types"
import {Helmet} from "react-helmet"

// data, config
import config from "../../../config"

// components
import CheckoutNavigator from "./CheckoutNavigator"
import CheckoutSidebar from "./CheckoutSidebar"
import Console from "./Console"
import Validation from "./Validation"
import {Block} from "../../shared"

// styling
import "./Checkout.scss"

function Checkout(props) {
  // TODO this is only used while developing the shop
  let sidebarPosition = (config.layout.sidebarPosition === "right" || config.layout.sidebarPosition === "mixed") ? "right" : "left"

  let step = config.checkoutSteps.find(s => s.key === props.stepName)
  let stepTitle = (step || {title:""}).title
  let helmetName = `Appentura - Checkout - ${stepTitle}`

  return (
    <Block 
      sidebar={<CheckoutSidebar stepName={props.stepName} onClickNext={props.onClickNext} />}
      sidebarPosition={sidebarPosition}
      console={<Console stepName={props.stepName} onClickNext={props.onClickNext} />}
      showConsoleInMain={true}
    >
      <Helmet>
        <title>{helmetName}</title>
        <meta id="meta-description" name="description" content={helmetName} />
        <meta id="og-title" property="og:title" content={helmetName} />
      </Helmet>
      <div className="c-checkout">
        <CheckoutNavigator stepName={props.stepName} />
        <div className="c-checkout-inner boxshadow">
          <h1>{props.title}</h1>
          {props.children}
          <Validation stepName={props.stepName}  />
        </div>
        
      </div>
    </Block>
  )
}

Checkout.propTypes = {
  stepName:PropTypes.string.isRequired,
  title:PropTypes.string.isRequired
}

export default Checkout